var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"lahi-loader"},[_c('img',{attrs:{"src":"/static/portal/assets/img/application/lahi/otp_lahi_kalkulator_preloader.gif"}})])
}]

export { render, staticRenderFns }